import React from 'react';
import { EarningsKPI } from '../EarningsKPI';
import { fmtMoney } from '../../lib/dashboard/helpers';

/**
 * The 8-tile "Shop overview" KPI panel (6 counters + 1-2 EarningsKPI
 * cards depending on whether the caller is also linked to a barber row).
 * Collapsible via the parent's `open` state.
 */
export const KpiGrid = ({ kpis, shopId, myBarberId, open, onToggle }) => (
  <div className="panel" data-testid="shop-overview" style={{ marginBottom: 18 }}>
    <div className="ph">
      <h3>Shop overview</h3>
      <button
        type="button"
        className="link"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls="shop-overview-body"
        data-testid="shop-overview-toggle"
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
      >
        {open ? 'Hide ▴' : 'Show ▾'}
      </button>
    </div>
    {open && (
      <div id="shop-overview-body" style={{ padding: 16 }}>
        <div className="kpis" style={{ marginBottom: 0 }}>
          <div className="kpi" data-testid="kpi-today">
            <div className="t">Today&apos;s bookings</div>
            <div className="v">{kpis.today.v}</div>
            <div className={`d ${kpis.today.delta > 0 ? 'up' : kpis.today.delta < 0 ? 'dn' : 'flat'}`}>
              {kpis.today.delta > 0 ? `▲ ${kpis.today.delta}` : kpis.today.delta < 0 ? `▼ ${Math.abs(kpis.today.delta)}` : '—'} vs same day last wk
            </div>
          </div>
          <div className="kpi" data-testid="kpi-week">
            <div className="t">This week</div>
            <div className="v">{kpis.week.v}</div>
            <div className={`d ${kpis.week.deltaPct > 0 ? 'up' : kpis.week.deltaPct < 0 ? 'dn' : 'flat'}`}>
              {kpis.week.deltaPct > 0 ? `▲ ${kpis.week.deltaPct}%` : kpis.week.deltaPct < 0 ? `▼ ${Math.abs(kpis.week.deltaPct)}%` : 'flat'}
            </div>
          </div>
          <div className="kpi" data-testid="kpi-revenue">
            <div className="t">Revenue today</div>
            <div className="v">{fmtMoney(kpis.revenue.v)}</div>
            <div className="d flat" data-testid="kpi-revenue-split">
              {kpis.revenue.cash > 0 && <>Cash {fmtMoney(kpis.revenue.cash)}</>}
              {kpis.revenue.cash > 0 && kpis.revenue.card > 0 && ' · '}
              {kpis.revenue.card > 0 && <>Card {fmtMoney(kpis.revenue.card)}</>}
              {kpis.revenue.cash === 0 && kpis.revenue.card === 0 && <>Prepaid only</>}
            </div>
          </div>
          <div className="kpi" data-testid="kpi-outstanding">
            <div className="t">Outstanding today</div>
            <div className="v" style={{ color: kpis.outstanding.v > 0 ? '#b91c1c' : 'var(--ink)' }}>
              {fmtMoney(kpis.outstanding.v)}
            </div>
            <div className="d flat">{kpis.outstanding.v > 0 ? 'still owing' : 'all settled'}</div>
          </div>
          <div className="kpi" data-testid="kpi-deposits">
            <div className="t">Deposits taken</div>
            <div className="v">{fmtMoney(kpis.deposits.v)}</div>
            <div className="d flat">{kpis.deposits.count} paid</div>
          </div>
          <div className="kpi" data-testid="kpi-noshow">
            <div className="t">No-show rate</div>
            <div className="v">{kpis.noShow.v.toFixed(1)}%</div>
            <div className={`d ${kpis.noShow.deltaPts < 0 ? 'up' : kpis.noShow.deltaPts > 0 ? 'dn' : 'flat'}`}>
              {kpis.noShow.deltaPts < 0 ? `▼ ${Math.abs(kpis.noShow.deltaPts).toFixed(1)}pts` : kpis.noShow.deltaPts > 0 ? `▲ ${kpis.noShow.deltaPts.toFixed(1)}pts` : '—'}
            </div>
          </div>

          {/* Earnings KPIs — always "this week". Two cards when the
              shop_admin is also linked to a barber row. */}
          <EarningsKPI shopId={shopId} label="Shop earnings · this week" dataTestId="kpi-earnings-shop" />
          {myBarberId && (
            <EarningsKPI shopId={shopId} barberId={myBarberId} label="Your earnings · this week" dataTestId="kpi-earnings-me" />
          )}
        </div>
      </div>
    )}
  </div>
);
